import { render, staticRenderFns } from "./StreamTailorBatches.vue?vue&type=template&id=1ba00d72&"
import script from "./StreamTailorBatches.vue?vue&type=script&lang=ts&"
export * from "./StreamTailorBatches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports